import {GET_ANALYSIS, GET_STORY, HANDLE_ERROR, ROOT_URL, GAME_URL, GET_COMPREHENSION_CONVERSATIONS} from '../../constants';


export const analysis = (state = [], action) => {
    switch (action.type) {
        case GET_ANALYSIS:
            return JSON.parse(action.speechData.analysis);
        default:
            return state;
    }
};

export const story = (state = [], action) => {
    switch (action.type) {
        case GET_STORY:
            return action.story;
        default:
            return state;
    }
}

export const comprehensionConversations = (state = { items: [], loading: false, error: null }, action) => {
    switch (action.type) {
        case 'GET_COMPREHENSION_CONVERSATIONS_START':
            return { items: [], loading: true, error: null };
        case GET_COMPREHENSION_CONVERSATIONS:
            return { items: Array.isArray(action.conversations) ? action.conversations : [], loading: false, error: null };
        case 'GET_COMPREHENSION_CONVERSATIONS_ERROR':
            return { items: [], loading: false, error: action.error };
        default:
            return state;
    }
};